/* ==========================================================================
   C&C MONOLITH — theme JS
   Ported from cc-website-final-v2.html. SPA router removed; the wipe now
   plays across real page loads. Bag rewired to Shopify Ajax Cart API:
   add    POST /cart/add.js   { id: variantId, quantity: 1 }
   read   GET  /cart.js
   remove POST /cart/change.js { id: lineKey, quantity: 0 }
   Motion engine v2 kept verbatim where the source allows.
   ========================================================================== */
(function(){
'use strict';

var R = window.CC_ROUTES || { root:'/', cart:'/cart', cart_add:'/cart/add', cart_change:'/cart/change', predictive:'/search/suggest', all:'/collections/all' };
var RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
var FINE = matchMedia('(hover:hover) and (pointer:fine)').matches;

function $(id){return document.getElementById(id)}
function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}
/* euro(): source used integers ("€85"). Shopify gives cents. */
function euro(cents){var n=cents/100;return '€'+(Number.isInteger(n)?n:n.toFixed(2))}

/* ============ ART (verbatim placeholder pairs) ============ */
const S='fill="none" stroke="#F4F2ED"';
const ART=[
[`<svg viewBox="0 0 100 100" fill="none" stroke="#F4F2ED" stroke-width="2"><circle cx="50" cy="55" r="26"/><circle cx="50" cy="55" r="17"/><path d="M38 33 L50 20 L62 33"/></svg>`,
 `<svg viewBox="0 0 100 100" fill="none" stroke="#F4F2ED" stroke-width="1.3"><circle cx="50" cy="50" r="33" stroke-dasharray="3 5"/><circle cx="50" cy="50" r="21"/></svg>`],
[`<svg viewBox="0 0 100 100" fill="none" stroke="#F4F2ED" stroke-width="2"><path d="M50 18 V82 M36 34 H64 M41 64 H59"/></svg>`,
 `<svg viewBox="0 0 100 100" fill="none" stroke="#F4F2ED" stroke-width="1.3"><path d="M50 14 V86" stroke-dasharray="4 4"/><circle cx="50" cy="50" r="30"/></svg>`],
[`<svg viewBox="0 0 100 100" fill="none" stroke="#F4F2ED" stroke-width="2"><path d="M32 38 Q50 16 68 38 Q75 60 50 82 Q25 60 32 38Z"/></svg>`,
 `<svg viewBox="0 0 100 100" fill="none" stroke="#F4F2ED" stroke-width="1.3"><path d="M32 38 Q50 16 68 38 Q75 60 50 82 Q25 60 32 38Z" stroke-dasharray="3 4"/><path d="M50 28 V72"/></svg>`],
[`<svg viewBox="0 0 100 100" fill="none" stroke="#F4F2ED" stroke-width="2"><path d="M50 18 C32 42 32 62 50 82 C68 62 68 42 50 18Z"/></svg>`,
 `<svg viewBox="0 0 100 100" fill="none" stroke="#F4F2ED" stroke-width="1.3"><path d="M50 18 C32 42 32 62 50 82 C68 62 68 42 50 18Z" stroke-dasharray="3 4"/><circle cx="50" cy="52" r="9"/></svg>`],
[`<svg viewBox="0 0 100 100" fill="none" stroke="#F4F2ED" stroke-width="2"><ellipse cx="50" cy="50" rx="32" ry="20"/><ellipse cx="50" cy="50" rx="20" ry="12"/></svg>`,
 `<svg viewBox="0 0 100 100" fill="none" stroke="#F4F2ED" stroke-width="1.3"><ellipse cx="50" cy="50" rx="32" ry="20" stroke-dasharray="3 4"/><path d="M18 50 H82"/></svg>`],
[`<svg viewBox="0 0 100 100" fill="none" stroke="#F4F2ED" stroke-width="2"><path d="M34 68 H66 M32 58 H68 M34 48 H66 M38 38 H62"/><circle cx="50" cy="54" r="30"/></svg>`,
 `<svg viewBox="0 0 100 100" fill="none" stroke="#F4F2ED" stroke-width="1.3"><circle cx="50" cy="54" r="30" stroke-dasharray="2 4"/><path d="M32 54 H68"/></svg>`],
[`<svg viewBox="0 0 100 100" fill="none" stroke="#F4F2ED" stroke-width="2"><path d="M25 50 A25 22 0 1 1 75 50 M25 50 V62 M75 50 V62"/></svg>`,
 `<svg viewBox="0 0 100 100" fill="none" stroke="#F4F2ED" stroke-width="1.3"><path d="M25 50 A25 22 0 1 1 75 50" stroke-dasharray="3 4"/><path d="M25 50 L75 50"/></svg>`],
[`<svg viewBox="0 0 100 100" fill="none" stroke="#F4F2ED" stroke-width="2"><circle cx="50" cy="50" r="24"/><path d="M50 26 V12"/></svg>`,
 `<svg viewBox="0 0 100 100" fill="none" stroke="#F4F2ED" stroke-width="1.3"><circle cx="50" cy="50" r="24" stroke-dasharray="2 4"/></svg>`],
[`<svg viewBox="0 0 100 100" fill="none" stroke="#F4F2ED" stroke-width="2"><circle cx="50" cy="52" r="27"/><path d="M68 33 L76 25"/></svg>`,
 `<svg viewBox="0 0 100 100" fill="none" stroke="#F4F2ED" stroke-width="1.3"><circle cx="50" cy="52" r="27" stroke-dasharray="4 3"/><circle cx="50" cy="52" r="14"/></svg>`],
[`<svg viewBox="0 0 100 100" fill="none" stroke="#F4F2ED" stroke-width="2"><path d="M46 14 L58 14 L54 70 L50 86 L46 70 Z"/></svg>`,
 `<svg viewBox="0 0 100 100" fill="none" stroke="#F4F2ED" stroke-width="1.3"><path d="M46 14 L58 14 L54 70 L50 86 L46 70 Z" stroke-dasharray="3 3"/><path d="M30 50 H70"/></svg>`],
[`<svg viewBox="0 0 100 100" fill="none" stroke="#F4F2ED" stroke-width="2"><circle cx="50" cy="58" r="22"/><rect x="36" y="20" width="28" height="20"/></svg>`,
 `<svg viewBox="0 0 100 100" fill="none" stroke="#F4F2ED" stroke-width="1.3"><circle cx="50" cy="58" r="22" stroke-dasharray="2 4"/><rect x="36" y="20" width="28" height="20" stroke-dasharray="2 4"/></svg>`],
[`<svg viewBox="0 0 100 100" fill="none" stroke="#F4F2ED" stroke-width="2"><path d="M22 44 H78 M22 56 H78 M30 44 V56 M42 44 V56 M54 44 V56 M66 44 V56"/></svg>`,
 `<svg viewBox="0 0 100 100" fill="none" stroke="#F4F2ED" stroke-width="1.3"><path d="M22 50 H78"/><path d="M22 40 H78 M22 60 H78" stroke-dasharray="3 3"/></svg>`]
];

/* ============ WIPE: cross-page transition ============ */
var wipe = $('wipe');
var navLock = false;
function navigateWithWipe(url){
  if(RM || !wipe || navLock){ location.href = url; return; }
  navLock = true;
  wipe.classList.add('on');
  setTimeout(function(){
    try{ sessionStorage.setItem('ccWipe','1'); }catch(e){}
    location.href = url;
  }, 440);
}
/* arrival: if we navigated with a wipe, land covered, then reveal */
(function(){
  var flagged = false;
  try{ flagged = sessionStorage.getItem('ccWipe') === '1'; if(flagged) sessionStorage.removeItem('ccWipe'); }catch(e){}
  if(!flagged || RM || !wipe) return;
  wipe.style.transition = 'none';
  wipe.classList.add('on');
  void wipe.offsetHeight;
  wipe.style.transition = '';
  requestAnimationFrame(function(){requestAnimationFrame(function(){
    wipe.classList.add('out');
    setTimeout(function(){ wipe.classList.remove('on','out'); }, 520);
  })});
})();
/* bfcache: never leave the veil up */
addEventListener('pageshow', function(e){
  if(e.persisted && wipe){ wipe.classList.remove('on','out'); navLock = false; }
});
/* intercept internal links */
document.addEventListener('click', function(e){
  if(e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
  var a = e.target.closest('a[href]');
  if(!a) return;
  if(a.hasAttribute('data-no-wipe') || a.target === '_blank' || a.hasAttribute('download')) return;
  var href = a.getAttribute('href');
  if(!href || href.charAt(0) === '#' || /^(mailto:|tel:|javascript:)/i.test(href)) return;
  var url;
  try{ url = new URL(a.href, location.href); }catch(err){ return; }
  if(url.origin !== location.origin) return;
  if(/^\/(checkout|account|admin|password)\b/.test(url.pathname)) return;
  if(url.pathname === location.pathname && url.search === location.search && url.hash) return;
  e.preventDefault();
  navigateWithWipe(url.href);
});

/* ============ header / menu / overlays ============ */
var hdr = $('hdr');
if(hdr){
  addEventListener('scroll', function(){ hdr.classList.toggle('scrolled', scrollY > 10); }, {passive:true});
}
var menu = $('menu'), burger = $('burger');
if(burger && menu){
  burger.onclick = function(){
    var open = menu.classList.toggle('on');
    document.body.classList.toggle('menu-open', open);
    this.setAttribute('aria-expanded', open);
  };
}

/* ============ BAG (Shopify Ajax Cart) ============ */
var bagEl = $('bag'), scrim = $('scrim');
var bagItems = $('bagItems'), bagCount = $('bagCount');
function sizeOf(item){
  var t = item.variant_title;
  return (t && t !== 'Default Title') ? String(t).toUpperCase() : 'ONE SIZE';
}
function renderBag(cart){
  if(!bagItems) return;
  if(bagCount) bagCount.textContent = cart.item_count;
  if(cart.item_count > 0){
    bagItems.innerHTML = cart.items.map(function(i){
      return '<div class="bitem"><span class="nm">'+esc(i.product_title)+'</span><span class="mono">'+esc(sizeOf(i))+' — '+euro(i.final_price)+'</span><div class="qstep" role="group" aria-label="Quantity for '+esc(i.product_title)+'"><button class="qm" data-key="'+esc(i.key)+'" data-qty="'+i.quantity+'" aria-label="Decrease quantity">−</button><span class="qty">'+i.quantity+'</span><button class="qp" data-key="'+esc(i.key)+'" data-qty="'+i.quantity+'" aria-label="Increase quantity">+</button></div><button class="brm" data-key="'+esc(i.key)+'" aria-label="Remove '+esc(i.product_title)+'">×</button></div>';
    }).join('');
  } else {
    bagItems.innerHTML = '<div class="empty"><div class="ampm bag-amp" aria-hidden="true"></div>YOUR BAG IS EMPTY</div>';
  }
}
function syncBag(){
  return fetch(R.cart + '.js', {headers:{'Accept':'application/json'}})
    .then(function(r){ return r.json(); })
    .then(function(c){ renderBag(c); return c; })
    .catch(function(){});
}
function addToBag(variantId){
  return fetch(R.cart_add + '.js', {
    method:'POST',
    headers:{'Content-Type':'application/json','Accept':'application/json'},
    body: JSON.stringify({ id: variantId, quantity: 1 })
  }).then(function(r){
    if(r.ok) return r.json().then(function(){ return syncBag(); });
    return r.json().then(function(err){ var e = new Error(err && (err.description || err.message) || 'Could not add'); e.cart = true; throw e; });
  });
}
function updateBagLine(key, quantity){
  return fetch(R.cart_change + '.js', {
    method:'POST',
    headers:{'Content-Type':'application/json','Accept':'application/json'},
    body: JSON.stringify({ id: key, quantity: quantity })
  }).then(function(r){ return r.json(); })
    .then(function(c){ renderBag(c); })
    .catch(function(){ syncBag(); });
}
function removeFromBag(key){ return updateBagLine(key, 0); }
function openBag(){ if(bagEl){ bagEl.classList.add('on'); if(scrim) scrim.classList.add('on'); } }
function closeBag(){ if(bagEl){ bagEl.classList.remove('on'); if(scrim) scrim.classList.remove('on'); } }
var bagBtn = $('bagBtn');
if(bagBtn){ bagBtn.addEventListener('click', function(e){ e.preventDefault(); openBag(); }); }
var bagClose = $('bagClose');
if(bagClose){ bagClose.onclick = closeBag; }
if(scrim){ scrim.addEventListener('click', closeBag); }
if(bagItems){
  bagItems.addEventListener('click', function(e){
    var rm = e.target.closest('.brm');
    if(rm){ rm.disabled = true; removeFromBag(rm.dataset.key); return; }
    var qm = e.target.closest('.qm');
    if(qm){ qm.disabled = true; updateBagLine(qm.dataset.key, Math.max(parseInt(qm.dataset.qty, 10) - 1, 0)); return; }
    var qp = e.target.closest('.qp');
    if(qp){ qp.disabled = true; updateBagLine(qp.dataset.key, parseInt(qp.dataset.qty, 10) + 1); return; }
  });
}
if(window.CC_CART){ renderBag(window.CC_CART); }

/* fly to bag + pulse (verbatim) */
function flyToBag(fromEl){
  if(RM || !bagBtn) return;
  var a = fromEl.getBoundingClientRect(), b = bagBtn.getBoundingClientRect();
  var f = document.createElement('div'); f.className = 'flybit';
  f.style.left = (a.left + a.width/2) + 'px'; f.style.top = (a.top + a.height/2) + 'px';
  document.body.appendChild(f);
  requestAnimationFrame(function(){ f.style.transform = 'translate(' + (b.left + b.width/2 - (a.left + a.width/2)) + 'px,' + (b.top + b.height/2 - (a.top + a.height/2)) + 'px) scale(.4)'; f.style.opacity = '0'; });
  setTimeout(function(){ f.remove(); }, 650);
  if(bagCount){ bagCount.classList.remove('pulse'); void bagCount.offsetWidth; bagCount.classList.add('pulse'); }
}

/* ============ PDP ============ */
(function(){
  var gal = $('gallery');
  if(!gal) return;
  var data = null;
  try{ data = JSON.parse($('cc-product-json').textContent); }catch(e){ return; }
  var gTags = ["MACRO","ON BODY","SCALE","PACKAGING"];
  var gIndex = 0, selectedVariant = null, selectedSize = null;
  var imgs = data.images || [];
  var art = ART[data.art % 12];
  var gShot = $('gShot'), gTag = $('gTag'), gCount = $('gCount');
  var sizes = $('pSizes'), sizeMsg = $('sizeMsg');

  function gLen(){ return imgs.length ? imgs.length : 4; }
  function renderShot(){
    gShot.classList.add('sw');
    setTimeout(function(){
      if(imgs.length){
        gShot.innerHTML = '<img src="'+esc(imgs[gIndex % imgs.length])+'" alt="'+esc(data.title)+'" style="width:100%;height:auto;display:block">';
        gTag.textContent = '';
      } else {
        gShot.innerHTML = art[gIndex % 2];
        gTag.textContent = gTags[gIndex];
      }
      gCount.textContent = (gIndex + 1) + ' / ' + gLen();
      gShot.classList.remove('sw');
    }, 140);
  }
  $('gPrev').onclick = function(){ var L = gLen(); gIndex = (gIndex + L - 1) % L; renderShot(); };
  $('gNext').onclick = function(){ var L = gLen(); gIndex = (gIndex + 1) % L; renderShot(); };
  var tx = null;
  gal.addEventListener('touchstart', function(e){ tx = e.touches[0].clientX; }, {passive:true});
  gal.addEventListener('touchend', function(e){
    if(tx === null) return;
    var dx = e.changedTouches[0].clientX - tx;
    if(Math.abs(dx) > 40){ var L = gLen(); gIndex = (gIndex + (dx < 0 ? 1 : L - 1)) % L; renderShot(); }
    tx = null;
  }, {passive:true});

  /* sizes */
  var sbtns = sizes ? sizes.querySelectorAll('button') : [];
  if(sbtns.length === 1){ selectedVariant = sbtns[0].dataset.variant; selectedSize = sbtns[0].dataset.s; }
  sbtns.forEach(function(b){
    b.addEventListener('click', function(){
      sbtns.forEach(function(x){ x.classList.remove('on'); });
      b.classList.add('on');
      selectedVariant = b.dataset.variant; selectedSize = b.dataset.s;
      sizes.classList.remove('err');
      sizeMsg.classList.remove('on');
      sizeMsg.textContent = 'SELECT A SIZE FIRST';
    });
  });

  /* claim → real add to cart */
  var claim = $('pClaim');
  if(claim){
    claim.onclick = function(){
      if(!selectedVariant){
        sizes.classList.add('err');
        sizeMsg.textContent = 'SELECT A SIZE FIRST';
        sizeMsg.classList.add('on');
        return;
      }
      claim.disabled = true;
      addToBag(selectedVariant).then(function(){
        claim.disabled = false;
        flyToBag(claim);
        setTimeout(openBag, 620);
      }).catch(function(err){
        claim.disabled = false;
        sizes.classList.add('err');
        sizeMsg.textContent = String(err && err.message || 'COULD NOT ADD').toUpperCase();
        sizeMsg.classList.add('on');
      });
    };
  }
})();

/* ============ collection filters (server-side nav) ============ */
(function(){
  var filters = $('filters');
  if(!filters) return;
  filters.addEventListener('click', function(e){
    var b = e.target.closest('button[data-href]');
    if(!b || b.classList.contains('on')) return;
    navigateWithWipe(b.dataset.href);
  });
})();

/* ============ search overlay ============ */
(function(){
  var searchEl = $('search'), sInput = $('sInput'), sRes = $('sRes'), sBtn = $('searchBtn'), sClose = $('sClose');
  if(!searchEl || !sInput || !sRes) return;
  var INDEX = window.CC_INDEX || [];
  var deb = null;
  /* word-boundary match: "ring" matches "Reaper Signet Ring" / "Rings" but not "Earrings" */
  function escRe(s){ return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  function wordMatch(text, q){ return q ? new RegExp('\\b' + escRe(q), 'i').test(text) : false; }
  function row(p, i){
    return '<button class="srow" style="animation-delay:' + Math.min(i * 35, 300) + 'ms" data-url="' + esc(p.u) + '"><span class="blk">' + esc(p.t) + '</span><span class="mono">' + esc(String(p.c || '').toUpperCase()) + ' — ' + euro(p.p) + '</span></button>';
  }
  function paint(list, q){
    sRes.dataset.mode = q ? 'results' : 'suggest';
    sRes.innerHTML = list.length ? list.map(row).join('') : '<div class="s-none">Nothing answers to that name.</div>';
    sRes.querySelectorAll('.srow').forEach(function(b){
      b.addEventListener('click', function(){ closeSearch(); navigateWithWipe(b.dataset.url); });
    });
  }
  function renderSearch(q){
    q = (q || '').trim().toLowerCase();
    if(INDEX.length){
      var list = q ? INDEX.filter(function(p){ return wordMatch(p.t, q) || wordMatch(String(p.c || ''), q); }) : INDEX.slice(0, 6);
      paint(list, q);
      return;
    }
    /* fallback: predictive search API */
    if(!q){ paint([], ''); return; }
    clearTimeout(deb);
    deb = setTimeout(function(){
      fetch(R.predictive + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8')
        .then(function(r){ return r.json(); })
        .then(function(d){
          var prods = (d.resources && d.resources.results && d.resources.results.products) || [];
          paint(prods.map(function(p){ return { t: p.title, u: p.url, c: p.type || '', p: p.price ? Math.round(parseFloat(p.price) * 100) : 0 }; }), q);
        }).catch(function(){});
    }, 200);
  }
  window.__ccOpenSearch = function(){ searchEl.classList.add('on'); renderSearch(''); setTimeout(function(){ sInput.focus(); }, 80); };
  function closeSearch(){ searchEl.classList.remove('on'); sInput.value = ''; }
  window.__ccCloseSearch = closeSearch;
  if(sBtn) sBtn.addEventListener('click', window.__ccOpenSearch);
  if(sClose) sClose.addEventListener('click', closeSearch);
  sInput.addEventListener('input', function(){ renderSearch(sInput.value); });
  sInput.addEventListener('keydown', function(e){
    if(e.key === 'Enter'){
      var q = sInput.value.trim();
      if(q) navigateWithWipe('/search?type=product&q=' + encodeURIComponent(q));
    }
  });
})();

/* esc key */
addEventListener('keydown', function(e){
  if(e.key !== 'Escape') return;
  var searchEl = $('search');
  if(searchEl && searchEl.classList.contains('on')){ if(window.__ccCloseSearch) window.__ccCloseSearch(); return; }
  if(bagEl && bagEl.classList.contains('on')){ closeBag(); return; }
  if(menu && menu.classList.contains('on') && burger) burger.click();
});

/* ============ MOTION ENGINE v2 ============ */
function stagger(scope){
  if(!scope) return;
  var cards = scope.querySelectorAll('.pcard:not(.vis)');
  cards.forEach(function(c, i){
    c.style.transitionDelay = Math.min(i * 40, 420) + 'ms';
    requestAnimationFrame(function(){ requestAnimationFrame(function(){
      c.classList.add('vis');
      setTimeout(function(){ c.style.transitionDelay = '0ms'; }, Math.min(i * 40, 420) + 600);
    }); });
  });
}

/* scroll progress */
var sprog = $('sprog');
function prog(){
  if(!sprog) return;
  var h = document.documentElement;
  var max = h.scrollHeight - innerHeight;
  sprog.style.transform = 'scaleX(' + (max > 0 ? Math.min(1, scrollY / max) : 0) + ')';
}
addEventListener('scroll', prog, {passive:true}); prog();

/* hero entrance */
addEventListener('load', function(){ document.body.classList.add('loaded'); });
setTimeout(function(){ document.body.classList.add('loaded'); }, 900);

/* magnetic buttons */
if(FINE && !RM){
  var magnetize = function(el){
    el.classList.add('mag');
    el.addEventListener('mousemove', function(e){
      var b = el.getBoundingClientRect();
      var x = e.clientX - (b.left + b.width/2), y = e.clientY - (b.top + b.height/2);
      el.style.transform = 'translate(' + x * .22 + 'px,' + y * .28 + 'px)';
    });
    el.addEventListener('mouseleave', function(){ el.style.transform = ''; });
  };
  document.querySelectorAll('.btn,.car-nav button,.capture form button').forEach(magnetize);
}

/* carousel: arrows + mouse drag */
var car = $('featuredGrid');
if(car){
  var step = function(){ var c = car.querySelector('.pcard'); return c ? c.getBoundingClientRect().width + 1 : 300; };
  var cp = $('carPrev'), cn = $('carNext');
  if(cp) cp.addEventListener('click', function(){ car.scrollBy({left: -step() * 2, behavior: 'smooth'}); });
  if(cn) cn.addEventListener('click', function(){ car.scrollBy({left: step() * 2, behavior: 'smooth'}); });
  if(FINE){
    var down = false, sx = 0, sl = 0, moved = 0;
    car.addEventListener('pointerdown', function(e){ down = true; moved = 0; sx = e.clientX; sl = car.scrollLeft; car.setPointerCapture(e.pointerId); });
    car.addEventListener('pointermove', function(e){ if(!down) return; var dx = e.clientX - sx; moved = Math.max(moved, Math.abs(dx)); car.scrollLeft = sl - dx; });
    var up = function(){ down = false; };
    car.addEventListener('pointerup', up); car.addEventListener('pointercancel', up);
    car.addEventListener('click', function(e){ if(moved > 8){ e.stopPropagation(); e.preventDefault(); moved = 0; } }, true);
  }
}

/* hero mark parallax */
if(FINE && !RM){
  var mark = document.querySelector('.amp-hero');
  if(mark){ addEventListener('mousemove', function(e){
    var x = (e.clientX / innerWidth - .5) * 14, y = (e.clientY / innerHeight - .5) * 10;
    mark.style.transform = 'translate(' + x + 'px,' + y + 'px)';
  }, {passive:true}); }
}

/* title scramble on reveal */
var SCR = '&XKRVZT§†17';
function scramble(el){
  var fin = el.textContent;
  if(!el.hasAttribute('aria-label')) el.setAttribute('aria-label', fin);
  if(RM || el.dataset.done) return; el.dataset.done = 1;
  var f = 0; var total = Math.max(14, fin.length * 2);
  (function tick(){
    el.textContent = fin.split('').map(function(ch, i){ return ch === ' ' ? ' ' : (i < f * fin.length / total ? ch : SCR[(Math.random() * SCR.length) | 0]); }).join('');
    if(f++ < total) setTimeout(tick, 26); else el.textContent = fin;
  })();
}

/* manifesto word split */
(function(){
  var big = document.querySelector('.manifesto .big');
  if(!big || RM) return;
  big.innerHTML = big.textContent.trim().split(' ').map(function(w){ return '<span class="w"><i>' + w + '</i></span>'; }).join(' ');
})();

/* reveals (merged upgraded observer, MPA scope) */
var io;
function observeReveals(){
  if(io) io.disconnect();
  io = new IntersectionObserver(function(es){ es.forEach(function(x){
    if(!x.isIntersecting) return;
    x.target.classList.add('in');
    var t = x.target.querySelector('.sec-title');
    if(t) scramble(t);
    if(x.target.classList.contains('manifesto')) x.target.classList.add('win');
    stagger(x.target);
    io.unobserve(x.target);
  }); }, {threshold: .15});
  document.querySelectorAll('.reveal, .manifesto').forEach(function(el){ io.observe(el); });
}
observeReveals();

/* initial card stagger for grids in first viewport */
['featuredGrid','catGrid','sameGrid'].forEach(function(id){ var g = $(id); if(g) stagger(g); });

})();
